<template>
    <div class="form-wrapper">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-position="top" class="custom-form">
            <h2 class="form-title">{{ $t('nav_item_5') }}</h2>

            <el-row :gutter="20">
                <el-col :span="12">
                    <el-form-item :label="$t('username')" prop="username">
                        <el-input v-model="ruleForm.username" clearable />
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item :label="$t('password')" prop="password">
                        <el-input v-model="ruleForm.password" show-password clearable autocomplete="new-password" />
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row :gutter="20">
                <el-col :span="12">
                    <el-form-item :label="$t('first_name')" prop="first_name">
                        <el-input v-model="ruleForm.first_name" clearable />
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item :label="$t('surname')" prop="last_name">
                        <el-input v-model="ruleForm.last_name" clearable />
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row :gutter="20">
                <el-col :span="12">
                    <el-form-item prop="date1" :label="$t('birth_date')">
                        <el-date-picker type="date" placeholder="Pick a date" v-model="ruleForm.date1"
                            style="width: 100%;" />
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item :label="$t('gender')">
                        <el-select v-model="ruleForm.gender" clearable placeholder="Select" style="width: 100%;">
                            <el-option :label="$t('female')" :value="0" />
                            <el-option :label="$t('male')" :value="1" />
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-form-item :label="$t('address')" prop="location">
                <el-input type="textarea" v-model="ruleForm.location" rows="2" />
            </el-form-item>

            <el-form-item :label="$t('device_id')" prop="device_id">
                <el-input v-model="ruleForm.device_id" clearable autocomplete="off" />
            </el-form-item>

            <!-- Медицинские поля -->
            <el-divider class="section-divider" content-position="left">{{ $t('health') }}</el-divider>

            <el-row :gutter="20">
                <el-col :span="12" v-for="field in medicalFields.slice(0, Math.ceil(medicalFields.length / 2))"
                    :key="field.key">
                    <el-form-item :label="$t(field.label)">
                        <el-select v-model="ruleForm[field.key]" placeholder="Select" style="width: 100%;">
                            <el-option :label="$t('no')" :value="0" />
                            <el-option :label="$t('yes')" :value="1" />
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="12" v-for="field in medicalFields.slice(Math.ceil(medicalFields.length / 2))"
                    :key="field.key">
                    <el-form-item :label="$t(field.label)">
                        <el-select v-model="ruleForm[field.key]" placeholder="Select" style="width: 100%;">
                            <el-option :label="$t('no')" :value="0" />
                            <el-option :label="$t('yes')" :value="1" />
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>

            <!-- Образ жизни -->
            <el-divider class="section-divider" content-position="left">{{ $t('lifestyle') }}</el-divider>

            <el-row :gutter="20">
                <el-col :span="8">
                    <el-form-item :label="$t('smoke')">
                        <el-select v-model="ruleForm.smoke" clearable placeholder="Select" style="width: 100%;">
                            <el-option :label="$t('no')" :value="0" />
                            <el-option :label="$t('yes')" :value="1" />
                            <el-option :label="$t('smoke_quit')" :value="2" />
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item :label="$t('alcohol')">
                        <el-select v-model="ruleForm.alcohol" clearable placeholder="Select" style="width: 100%;">
                            <el-option :label="$t('never')" :value="0" />
                            <el-option :label="$t('rarely')" :value="1" />
                            <el-option :label="$t('regular')" :value="2" />
                            <el-option :label="$t('often')" :value="3" />
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item :label="$t('sport')">
                        <el-select v-model="ruleForm.sport" clearable placeholder="Select" style="width: 100%;">
                            <el-option :label="$t('never')" :value="0" />
                            <el-option :label="$t('rarely')" :value="1" />
                            <el-option :label="$t('aweek')" :value="2" />
                            <el-option :label="$t('everyday')" :value="3" />
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row :gutter="20">
                <el-col :span="12">
                    <el-form-item :label="$t('diet')">
                        <el-select v-model="ruleForm.nutrition" clearable placeholder="Select" style="width: 100%;">
                            <el-option :label="$t('other')" :value="0" />
                            <el-option :label="$t('normal')" :value="1" />
                            <el-option :label="$t('vegetarian')" :value="2" />
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item :label="$t('eat')">
                        <el-select v-model="ruleForm.eat" clearable placeholder="Select" style="width: 100%;">
                            <el-option :label="$t('other')" :value="0" />
                            <el-option :label="$t('1time')" :value="1" />
                            <el-option :label="$t('2time')" :value="2" />
                            <el-option :label="$t('3time')" :value="3" />
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-form-item :label="$t('emotional')">
                <el-select v-model="ruleForm.emotional_state" clearable placeholder="Select" style="width: 100%;">
                    <el-option :label="$t('poor')" :value="0" />
                    <el-option :label="$t('satisfactory')" :value="1" />
                    <el-option :label="$t('good')" :value="2" />
                    <el-option :label="$t('excellent')" :value="3" />
                </el-select>
            </el-form-item>

            <el-form-item :label="$t('avatar')">
                <input type="file" id="avatar" name="avatar" />
            </el-form-item>

            <el-form-item class="form-actions">
                <el-button type="primary" @click="submitForm('ruleForm')">{{ $t('create') }}</el-button>
                <el-button @click="resetForm('ruleForm')">{{ $t('reset') }}</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
import moment from 'moment';

export default {
    data() {
        return {
            ruleForm: {
                username: '',
                first_name: '',
                last_name: '',
                date1: '',
                location: '',
                password: '',
                device_id: '',
                gender: '',
                heart: 0,
                breast: 0,
                diabet: 0,
                asthma: 0,
                hypertension: 0,
                medicines: 0,
                allergies: 0,
                operations: 0,
                diseases: 0,
                hereditary_diabetes: 0,
                smoke: 0,
                alcohol: 1,
                sport: 1,
                nutrition: 1,
                eat: 3,
                depression: 0,
                emotional_state: 2,
                psychotropic_drugs: 0
            },
            rules: {
                username: [
                    { required: true, message: 'Please input username', trigger: 'blur' },
                    { min: 3, max: 15, message: 'Length should be 3 to 15', trigger: 'blur' }
                ],
                password: [
                    { required: true, message: 'Please input password', trigger: 'blur' },
                    { min: 6, max: 15, message: 'Length should be 6 to 15', trigger: 'blur' }
                ],
                first_name: [{ required: true, message: 'Please input first name', trigger: 'blur' }],
                last_name: [{ required: true, message: 'Please input last name', trigger: 'blur' }],
                date1: [{ type: 'date', required: true, message: 'Please pick a date', trigger: 'change' }],
                location: [{ required: true, message: 'Please input location', trigger: 'blur' }],
                device_id: [{ required: true, message: 'Please input device id', trigger: 'blur' }]
            },
            medicalFields: [
                { key: 'heart', label: 'heart' },
                { key: 'breast', label: 'breast' },
                { key: 'diabet', label: 'diabets' },
                { key: 'asthma', label: 'asthma' },
                { key: 'hypertension', label: 'hypertension' },
                { key: 'medicines', label: 'medicines' },
                { key: 'allergies', label: 'allergia' },
                { key: 'operations', label: 'operations' },
                { key: 'diseases', label: 'disease' },
                { key: 'hereditary_diabetes', label: 'history_diabets' },
                { key: 'depression', label: 'depression' },
                { key: 'psychotropic_drugs', label: 'drugs' }
            ]
        };
    },
    methods: {
        submitForm(formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    const formData = new FormData();
                    const headers = {
                        Authorization: 'Token ' + sessionStorage.getItem('key')
                    };

                    const file = document.querySelector('#avatar').files[0];
                    if (file) {
                        formData.append('avatar', file);
                    }

                    Object.keys(this.ruleForm).forEach(key => {
                        const value = this.ruleForm[key];
                        if (key === 'date1') {
                            formData.append('birth_date', moment(value).format('YYYY-MM-DD'));
                        } else {
                            formData.append(key, value);
                        }
                    });

                    axios.post('/users/register/', formData, { headers } )
                        .then(res => res.json())
                        .then(data => {
                            this.$message.success(this.$t('success'));
                        })
                        .catch(err => {
                            console.error(err);
                            this.$message.error(this.$t('error'));
                        });
                } else {
                    console.log('error submit!');
                    return false;
                }
            });
        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
        }
    }
};
</script>


<style scoped>
.section {
    width: 100%;
    overflow: hidden;
}

.demo-ruleForm {
    margin-top: 20px;
    margin-left: 10px;
}

.avatar-uploader {
    width: 178px;
    margin: 0 0 20px 20px;
    border: 1px dashed #d9d9d9 !important;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.avatar-uploader .el-upload:hover {
    border-color: #409EFF;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
}

.avatar {
    width: 178px;
    height: 178px;
    display: block;
}

.el-select {
    width: 100%;
}

.form-wrapper {
    width: 98%;
    padding: 30px 40px;
    margin: 30px;
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 4px 14px rgba(0, 0, 0, 0.08);
    box-sizing: border-box;
}

.form-title {
    text-align: center;
    font-size: 22px;
    margin-bottom: 20px;
    color: #333;
}

.custom-form ::v-deep .el-form-item__label {
    font-weight: 500;
}

.form-actions {
    text-align: right;
    margin-top: 30px;
}
</style>